<!--Vista para crear un nuevo Plan(Afiliación)-->
<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col cols="12">
        <v-row justify="center">
          <v-col cols="10" md="8" xl="6" class="elevation-1 mb-5 primary white--text text-center">
            <h1 v-if="isNewAffiliation" class="display-2">Registro de nueva afiliación</h1>
            <h1 v-else class="display-2">Actualización de afiliación</h1>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col cols="12" sm="11">
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-stepper v-model="currentStep" vertical :non-linear="(isNewAffiliation)?false:true">
                <v-stepper-step
                  :editable="(isNewAffiliation)?false:true"
                  :complete="currentStep > 1"
                  step="1"
                  color="accent"
                >Configuración de la afiliación</v-stepper-step>

                <v-stepper-content step="1">
                  <v-row v-if="currentStep==1">
                    <v-col cols="12" sm="6" lg="4" xl="3">
                      <v-text-field
                        v-model.trim="newAffiliation.name"
                        :rules="affiliationNameRules"
                        label="Nombre de la afiliación *"
                        hint="Ej: Afiliación para directivos de empresas"
                        required
                        prepend-icon="fas fa-medal"
                      ></v-text-field>
                    </v-col>
                    <!-- <v-col cols="12" sm="6" lg="4" xl="3">
                      <v-select
                        v-model="newAffiliation.category"
                        :items="affiliationCategory"
                        label="Categoría de la afiliación *"
                        prepend-icon="fas fa-filter"
                        required
                        :rules="categoryRules"
                      ></v-select>
                    </v-col>-->
                    <v-col cols="12" sm="6" lg="4" xl="3">
                      <v-select
                        v-model="newAffiliation.subcategory"
                        :items="affiliationSubcategories"
                        label="Sector de la afiliación *"
                        prepend-icon="fas fa-filter"
                        required
                        :rules="subcategoryRules"
                      ></v-select>
                    </v-col>

                    <v-col cols="12" sm="6" xl="3">
                      <v-text-field
                        v-model="newAffiliation.contactDetails.tel"
                        :rules="telRules"
                        label="Teléfono de contacto *"
                        required
                        prepend-icon="fas fa-phone"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" xl="3">
                      <v-text-field
                        v-model.trim="newAffiliation.contactDetails.email"
                        :rules="emailRules"
                        label="Correo electrónico *"
                        required
                        prepend-icon="fas fa-envelope"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" xl="3">
                      <v-text-field
                        v-model.trim="newAffiliation.contactDetails.webSite"
                        :rules="webSiteRules"
                        label="Sitio Web"
                        prepend-icon="fas fa-globe"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="6" lg="4" xl="3">
                      <v-text-field
                        v-model.trim="newAffiliation.socialMedia.facebook"
                        :rules="websiteRules"
                        label="Perfil de Facebook"
                        hint="Facebook URL"
                        prepend-icon="fab fa-facebook-square"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" lg="4" xl="3">
                      <v-text-field
                        v-model.trim="newAffiliation.socialMedia.twitter"
                        :rules="websiteRules"
                        label="Perfil de Twitter"
                        hint="Twitter URL"
                        prepend-icon="fab fa-twitter-square"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" lg="4" xl="3">
                      <v-text-field
                        v-model.trim="newAffiliation.socialMedia.linkedin"
                        :rules="websiteRules"
                        label="Perfil de LinkedIn"
                        hint="LinkedIn URL"
                        prepend-icon="fab fa-linkedin"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" lg="4" xl="3">
                      <v-text-field
                        v-model.trim="newAffiliation.socialMedia.youtube"
                        :rules="websiteRules"
                        label="Video promocional"
                        hint="Youtube URL"
                        prepend-icon="fab fa-youtube"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" lg="8" xl="9">
                      <v-combobox
                        v-model="newAffiliation.tags"
                        :items="exampleTags"
                        :search-input.sync="search"
                        hide-selected
                        hint="Ej. Ventas, Control."
                        label="Tags"
                        multiple
                        persistent-hint
                        small-chips
                        prepend-icon="fas fa-key"
                      >
                        <template v-slot:no-data>
                          <v-list-item>
                            <v-list-item-content>
                              <v-list-item-title>
                                No hay resultados para "
                                <strong>{{ search }}</strong>". Presiona
                                <kbd>enter</kbd> para crear una nueva keyword.
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </template>
                      </v-combobox>
                    </v-col>
                  </v-row>
                  <!-- :disabled="(!newAffiliation.name || !newAffiliation.ammount || !newAffiliation.subcategory || !valid )" -->
                  <v-btn
                    color="accent"
                    class="my-3"
                    @click="validate()"
                    :disabled="(!newAffiliation.name || !newAffiliation.subcategory || !newAffiliation.contactDetails.tel || !newAffiliation.contactDetails.email || !valid)"
                  >Continuar</v-btn>
                </v-stepper-content>

                <v-stepper-step
                  :complete="currentStep > 2"
                  step="2"
                  color="accent"
                  :editable="(isNewAffiliation)?false:true"
                >
                  Detalles de la afiliación
                  <small>¡Agrega todas las características de la afiliación!</small>
                </v-stepper-step>

                <v-stepper-content step="2">
                  <v-row v-if="currentStep==2">
                    <v-col cols="12">
                      <tiptap-vuetify v-model="newAffiliation.details" :extensions="extensions" />
                    </v-col>
                  </v-row>
                  <!-- :disabled="(!newAffiliation.details || !valid )" -->
                  <v-btn
                    color="accent"
                    class="my-3"
                    @click="currentStep++"
                    :disabled="(!newAffiliation.details)"
                  >Continuar</v-btn>
                  <v-btn text @click="currentStep--">Regresar</v-btn>
                </v-stepper-content>

                <v-stepper-step
                  :editable="(isNewAffiliation)?false:true"
                  :complete="currentStep > 3"
                  step="3"
                  color="accent"
                >Preguntas frecuentes y publicidad</v-stepper-step>

                <v-stepper-content step="3">
                  <v-row v-if="currentStep==3">
                    <v-col cols="12">
                      <h2 class="title">Preguntas frecuentes</h2>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      xl="4"
                      class="pt-0"
                      v-for="(item, index) in newAffiliation.faqs"
                      :key="`question${index}`"
                    >
                      <v-text-field
                        :ref="item.question"
                        label="Pregunta"
                        prepend-icon="fas fa-question-circle"
                        v-model.trim="newAffiliation.faqs[index].question"
                      ></v-text-field>
                      <v-textarea
                        :ref="item.answer"
                        label="Respuesta"
                        prepend-icon="fas fa-check-circle"
                        v-model.trim="newAffiliation.faqs[index].answer"
                      ></v-textarea>
                      <v-row justify="center">
                        <v-btn
                          v-if="newAffiliation.faqs.length>1"
                          color="secondary"
                          @click="(newAffiliation.faqs.length>1)?deleteQuestion(item.question):''"
                          class="mx-2"
                        >
                          <v-icon x-small>fas fa-minus</v-icon>
                        </v-btn>
                        <v-btn
                          v-if="index==newAffiliation.faqs.length-1"
                          color="primary"
                          @click="addQuestion()"
                        >
                          <v-icon x-small>fas fa-plus</v-icon>
                        </v-btn>
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-row class="mb-5">
                    <v-col cols="12">
                      <h2 class="title">Publicidad de la afiliación</h2>
                    </v-col>
                    <v-col cols="12">
                      <file-pond
                        name="affiliation-img"
                        ref="pondAffiliation"
                        label-idle="Agrega una imagen a la afiliación..."
                        accepted-file-types="image/jpeg, image/png"
                      />
                    </v-col>
                    <v-col cols="12">
                      <h2 class="title">Patrocinadores</h2>
                    </v-col>
                    <v-col cols="12">
                      <file-pond
                        name="plan-img"
                        ref="pondSponsors"
                        label-idle="Agrega los logos de los patrocinadores aquí...(.png)"
                        allow-multiple="true"
                        max-files="8"
                        accepted-file-types="image/png"
                        allowImagePreview="false"
                      />
                    </v-col>
                  </v-row>
                  <v-btn
                    color="accent"
                    class="my-3"
                    :disabled="!valid"
                    @click="processFile(), validate()"
                  >Continuar</v-btn>
                  <v-btn text @click="currentStep--">Regresar</v-btn>
                </v-stepper-content>

                <v-stepper-step
                  :editable="(isNewAffiliation)?false:true"
                  :complete="currentStep > 4"
                  step="4"
                  color="accent"
                >
                  Niveles
                  <small>¿Oro, plata o bronce?</small>
                </v-stepper-step>

                <v-stepper-content step="4">
                  <v-row align="center" v-if="currentStep==4">
                    <v-col cols="12">
                      <h2 class="title text-center">
                        Para dar de alta la afiliación es necesario asignar un nombre. Si lo desea puede agregar niveles a su afiliación, por ejemplo, Oro, Plata o Bronce, simplemente asigna un nombre al nivel, su costo y beneficios.
                        Ejemplo -
                        <image-card :img="tierImg"></image-card>
                      </h2>
                    </v-col>
                  </v-row>
                  <v-row class="px-3" v-if="currentStep==4">
                    <v-col cols="11" class="pb-0">
                      <h2 class="title">Niveles</h2>
                    </v-col>
                    <v-col
                      cols="11"
                      sm="6"
                      lg="4"
                      xl="3"
                      class="pt-0"
                      v-for="(tier, index) in newAffiliation.tiers"
                      :key="`tier${index}`"
                    >
                      <v-text-field
                        class="mb-3"
                        :rules="tierNameRules"
                        label="Nombre del nivel *"
                        hint="Ej: Oro"
                        required
                        prepend-icon="fas fa-crown"
                        v-model.trim="newAffiliation.tiers[index].name"
                      ></v-text-field>
                      <v-text-field
                        class="mb-3"
                        :rules="tierPriceRules"
                        label="Costo *"
                        type="number"
                        prepend-icon="fas fa-dollar-sign"
                        v-model.number="newAffiliation.tiers[index].amount"
                      ></v-text-field>
                      <v-select
                        v-model="newAffiliation.tiers[index].interval"
                        :items="affiliationIntervals"
                        label="Perioricidad de cobro *"
                        prepend-icon="fas fa-calendar-day"
                        required
                        :rules="tierIntervalRules"
                      ></v-select>
                      <v-combobox
                        :rules="tierBenefitsRules"
                        class="mb-3"
                        v-model="newAffiliation.tiers[index].benefits"
                        prepend-icon="fas fa-check"
                        hide-selected
                        :hint="`Máximo 60 caracteres por beneficio.`"
                        :label="`Beneficios *`"
                        multiple
                        persistent-hint
                        small-chips
                        required
                        @change="validateBenefitLength(index)"
                        :search-input.sync="search"
                      >
                        <template v-slot:no-data>
                          <v-list-item>
                            <v-list-item-content>
                              <v-list-item-title>
                                Presiona enter para agregar el beneficio (
                                {{ (search!=null && search!='' && search!=undefined)?search.length:'0' }}
                                <!-- <span v-if="newAffiliation.tiers[index].benefits[newAffiliation.tiers[index].benefits.length]== undefined">0</span>
                                <span v-else>
                                    {{ newAffiliation.tiers[index].benefits[newAffiliation.tiers[index].benefits.length].length}}
                                </span>-->
                                )
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </template>
                      </v-combobox>
                      <v-row justify="center">
                        <v-btn
                          v-if="newAffiliation.tiers.length>1"
                          color="secondary"
                          @click="deleteTier(tier.name)"
                          class="mx-2"
                        >
                          <v-icon x-small>fas fa-minus</v-icon>
                        </v-btn>
                        <v-btn
                          v-if="index==newAffiliation.tiers.length-1"
                          color="primary"
                          @click="addTier()"
                        >
                          <v-icon x-small>fas fa-plus</v-icon>
                        </v-btn>
                      </v-row>
                    </v-col>
                  </v-row>
                  <!--  -->
                  <v-btn
                    color="accent"
                    class="my-3"
                    :disabled="!valid"
                    @click="checkTiers()"
                  >Continuar</v-btn>
                  <v-btn text @click="currentStep--">Regresar</v-btn>
                </v-stepper-content>

                <v-stepper-step :editable="(isNewAffiliation)?false:true" :complete="currentStep > 5" step="5" color="accent">
                  Mensaje de bienvenida
                  <small>Este mensaje se colocará en el correo de bienvenida cada vez que una persona pague su membresía a tu organización.</small>
                </v-stepper-step>

                <v-stepper-content step="5">
                  <v-row v-if="currentStep==5">
                    <v-col cols="12">
                      <tiptap-vuetify
                        v-model="newAffiliation.welcomeMessage"
                        :extensions="extensions"
                      />
                    </v-col>
                  </v-row>
                  <!-- :disabled="(!newAffiliation.welcomeMessage || !valid )" -->
                  <v-btn
                    color="accent"
                    class="my-3"
                    @click="currentStep++"
                  >Continuar</v-btn>
                  <v-btn text @click="currentStep--">Regresar</v-btn>
                </v-stepper-content>
                <v-stepper-step
                  :editable="(isNewAffiliation || currentStep == 3)?false:(valid)?true:false"
                  step="6"
                  color="accent"
                >
                  Información adicional de los afiliados
                  <small>Agrega campos personalizados para obtener información que desees conocer.</small>
                </v-stepper-step>
                <v-stepper-content step="6">
                  <v-row v-if="currentStep==6">
                    <v-col cols="12">
                      
                      <h2
                        class="title text-center"
                      >Campos predefinidos para formulario para registro de afiliado
                        <v-tooltip top max-width="350px">
                          <template v-slot:activator="{ on }">
                            <v-icon color="primary" dark v-on="on">mdi-help-circle</v-icon>
                          </template>
                          <span>La información que sale en los siguientes campos es la que se le solicita a los usuarios al momento de afiliarse.</span>
                        </v-tooltip>
                      </h2>
                      <v-row justify="center">
                        <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          label="Nombre(s)"
                          required
                          prepend-icon="fas fa-user"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          label="Apellidos"
                          prepend-icon="fas fa-user"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          label="E-mail"
                          prepend-icon="fas fa-envelope"
                        ></v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="6"
                        md="4"
                      >
                        <v-text-field
                          label="Empresa/Institución"
                          prepend-icon="fas fa-industry"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12"
                        sm="6"
                        md="4">
                        <v-text-field
                          label="Teléfono"
                          prepend-icon="fas fa-phone"
                        ></v-text-field>
                      </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12">
                      <h2
                        class="title text-center"
                      >Si lo deseas puedes agregar campos para conocer información adicional de tus afiliados. Estos campos serán visibles al momento de afiliarse a tu organización.
                        <v-tooltip top max-width="350px">
                          <template v-slot:activator="{ on }">
                            <v-icon color="primary" dark v-on="on">mdi-help-circle</v-icon>
                          </template>
                          <span>Además de la información que se muestra arriba, ¿Qué deseas saber sobre tus afiliados? Ejemplo: Profesión, edad, género, ciudad, etc.</span>
                        </v-tooltip>
                      </h2>
                      <v-row justify="center">
                        <v-switch
                          color="secondary"
                          v-model="additionalFields"
                          class="ml-3 ml-sm-0"
                          label="Deseo agregar campos adicionales"
                        ></v-switch>
                      </v-row>
                    </v-col>
                    <v-col v-if="additionalFields" cols="12" class="pt-0">
                      <v-row
                        v-for="(field, index) in newAffiliation.extraFields"
                        :key="index"
                        justify="center"
                      >
                        <v-col cols="12" sm="6" md="4" lg="3">
                          <p class="font-weight-bold">Tipo de campo</p>
                          <v-radio-group
                            v-model="newAffiliation.extraFields[index].fieldType"
                            :mandatory="false"
                            class="ml-2"
                          >
                            <v-radio color="secondary" label="Campo de texto" value="text"></v-radio>
                            <v-radio color="secondary" label="Lista de opciones" value="select"></v-radio>
                          </v-radio-group>
                          <p class="font-weight-bold">Opciones</p>
                          <v-switch
                            class="ml-2"
                            color="secondary"
                            v-model="newAffiliation.extraFields[index].required"
                            label="¿Obligatorio?"
                          ></v-switch>
                        </v-col>

                        <v-col cols="12" sm="6" md="3" lg="4">
                          <p class="font-weight-bold">Configuración</p>
                          <v-text-field
                            v-model="newAffiliation.extraFields[index].name"
                            :rules="extraFieldRules"
                            label="Nombre del campo o pregunta"
                          ></v-text-field>
                          <v-text-field
                            v-model="newAffiliation.extraFields[index].description"
                            label="Descripción"
                          ></v-text-field>
                          <v-combobox
                            v-if="newAffiliation.extraFields[index].fieldType==='select'"
                            v-model="newAffiliation.extraFields[index].options"
                            hide-selected
                            hint="Agrega las opciones de tu campo."
                            label="Opciones del campo"
                            multiple
                            persistent-hint
                            small-chips
                          >
                            <template v-slot:no-data>
                              <v-list-item>
                                <v-list-item-content>
                                  <v-list-item-title>
                                    Presiona
                                    <kbd>enter</kbd> para crear una nueva keyword.
                                  </v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                            </template>
                          </v-combobox>
                        </v-col>

                        <v-spacer></v-spacer>

                        <v-col
                          cols="12"
                          sm="6"
                          md="4"
                          v-if="newAffiliation.extraFields[index].fieldType==='text'"
                        >
                          <p class="font-weight-bold">Vista previa</p>
                          <v-text-field
                            v-bind:label="newAffiliation.extraFields[index].name || 'Nombre del campo o pregunta'"
                            v-bind:hint="newAffiliation.extraFields[index].description || 'Ej. Descripción del campo'"
                            persistent-hint
                          ></v-text-field>
                        </v-col>

                        <v-col
                          cols="12"
                          sm="6"
                          md="4"
                          v-if="newAffiliation.extraFields[index].fieldType==='select'"
                        >
                          <p class="font-weight-bold">Vista previa</p>
                          <v-select
                            :items="newAffiliation.extraFields[index].options"
                            v-bind:label="newAffiliation.extraFields[index].name || 'Nombre del campo'"
                            v-bind:hint="newAffiliation.extraFields[index].description || 'Ej. Descripción del campo'"
                            persistent-hint
                          ></v-select>
                        </v-col>

                        <v-col cols="12" class="mt-5 mt-md-0">
                          <v-row justify="center" align="center">
                            <v-btn
                              v-if="newAffiliation.extraFields.length>1"
                              color="secondary"
                              @click="(newAffiliation.extraFields.length>1)?deleteField(field.name):''"
                              class="mx-2"
                            >
                              <v-icon x-small>fas fa-minus</v-icon>
                            </v-btn>
                            <v-btn
                              v-if="index==newAffiliation.extraFields.length-1"
                              color="primary"
                              @click="addField()"
                            >
                              <v-icon x-small>fas fa-plus</v-icon>
                            </v-btn>
                          </v-row>
                        </v-col>

                        <v-col cols="12" class="d-md-none my-5 my-md-0">
                          <v-divider />
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-row v-if="isNewAffiliation" class="px-5 pb-5 my-3">
                    <v-btn color="accent" @click="validateOrganizerStatus('create')" :disabled=" !valid ">Guardar</v-btn>
                    <v-btn text @click="currentStep--">Regresar</v-btn>
                    <!-- Poner cuando este completado lo del preview del evento
                    <div class="flex-grow-1"></div>
                    <v-btn color="secondary" @click="preview()">Vista previa</v-btn>
                    -->
                  </v-row>
                  <v-row v-else class="px-5 pb-5 my-3">
                    <v-btn color="accent" @click="validateOrganizerStatus('update')" :disabled=" !valid ">Guardar</v-btn>
                    <v-btn text @click="currentStep--">Regresar</v-btn>
                  </v-row>
                </v-stepper-content>
              </v-stepper>
            </v-form>
          </v-col>
        </v-row>
        <v-dialog v-model="bankDataDialog" max-width="600px">
          <v-card>
            <p class="display-1 font-weight-bold px-7 pt-5 mb-2">Datos bancarios <i class="fas fa-university amber--text"></i></p>
            
            <p class="body-2 px-7">Esta información será solicitada solamente una ocasión, es aquí donde realizaremos las transferencias de tus ventas los días martes y viernes. <i class="fas fa-exclamation-triangle accent--text"></i></p>
            <v-divider class="pt-3"></v-divider>
            <v-form ref="formBankData" v-model="bankDataValid" lazy-validation>
              <v-row class="ma-0">
                <v-col cols="12" class="px-5">
                  <v-text-field
                    v-model="bankDataOrganization.rfc"
                    label="RFC"
                    :rules="rfcRules"
                    prepend-icon="fas fa-id-card"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="px-5">
                  <v-text-field
                    v-model="bankDataOrganization.razonSocial"
                    label="Razón social"
                    :rules="razonSocialRules"
                    prepend-icon="fas fa-file-contract"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="px-5">
                  <v-text-field
                    v-model="bankDataOrganization.bank"
                    label="Banco"
                    :rules="bankRules"
                    required
                    prepend-icon="fas fa-university"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="px-5">
                  <v-text-field
                    v-model="bankDataOrganization.clabe"
                    label="Cuenta CLABE (Clave Bancaria Estandarizada)"
                    :rules="clabeRules"
                    prepend-icon="fas fa-money-check-alt"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="px-5">
                  <v-text-field
                    v-model="bankDataOrganization.confirmClabe"
                    label="Confirmación Cuenta CLABE (Clave Bancaria Estandarizada)"
                    :rules=" [(bankDataOrganization.clabe==bankDataOrganization.confirmClabe) || 'La confirmación de la CLABE no es correcta']"
                    prepend-icon="fas fa-money-check-alt"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="px-5">
                  <v-text-field
                    v-model="bankDataOrganization.billEmail"
                    label="Email que recibirá las facturas"
                    :rules="emailRules"
                    required
                    prepend-icon="fas fa-envelope"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-form>
            <v-divider></v-divider>
            <v-card-actions class="px-7 pb-4">
              <v-row justify="space-between">
                <v-btn color="red darken-3" @click="bankDataDialog = false" dark>Cancelar</v-btn>
                <v-btn color="secondary" @click="editOrganization( bankDataOrganization)" :disabled=" bankDataOrganization.rfc=='' || bankDataOrganization.razonSocial=='' || bankDataOrganization.bank=='' || bankDataOrganization.clabe=='' || bankDataOrganization.confirmClabe=='' || bankDataOrganization.billEmail=='' || !bankDataValid">Guardar</v-btn>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapMutations, mapActions, mapState } from "vuex";
import {
  TiptapVuetify,
  Heading,
  Bold,
  Italic,
  Strike,
  Underline,
  Code,
  Paragraph,
  BulletList,
  OrderedList,
  ListItem,
  Link,
  Blockquote,
  HardBreak,
  HorizontalRule,
  History
} from "tiptap-vuetify";

//Validaciones
import { validations } from "@/helpers/validations.js";
import { imageHelper } from "@/helpers/imageProcessing.js";

// Base64
import { Base64 } from "js-base64";

// Filepond
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import vueFilePond from "vue-filepond";
import "filepond/dist/filepond.min.css";
const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginImagePreview
);

// Components
import imageCard from "@/components/landing/image-card";

export default {
  components: {
    FilePond,
    TiptapVuetify,
    imageCard
  },
  data() {
    return {
      originalTiersQty: 0,
      tierImg:
        "https://test-upload-files-beta-wechamber.s3.us-east-2.amazonaws.com/EjemploAfiliacion.jpg",
      isNewAffiliation: true,
      valid: false,
      currentStep: 1,
      additionalFields: false,
      search: "",
      bankDataValid: false,
      bankDataDialog: false,
      bankDataOrganization: {
        rfc: "",
        clabe: "",
        bank: "",
        razonSocial: "",
        billEmail: ""
      },
      // OPCIONES DEL EDITOR
      extensions: [
        History,
        [Heading, { options: { levels: [1, 2, 3] } }],
        Paragraph,
        Bold,
        Underline,
        Strike,
        Italic,
        ListItem,
        BulletList,
        OrderedList,
        Blockquote,
        Link,
        Code,
        HorizontalRule
      ],

      // DATOS DE LOS SELECTS
      affiliationSubcategories: [
        "Agricultura, Pesca y Caza",
        "Minería",
        "Construcción",
        "Manufactura",
        "Comercio",
        "Transportes",
        "Información en medios masivos",
        "Servicios financieros y de seguros",
        "Servicios inmobiliarios",
        "Servicios profesionales",
        "Corporativos",
        "Servicios educativos",
        "Servicios de salud y asistencia social",
        "Servicios de esparcimiento culturales y deportivos",
        "Servicios de alojamiento temporal",
        "Servicios de preparación de bebidas",
        "Actividades gubernamentales",
        "Otros servicios"
      ],
      affiliationIntervals: [
        { text: "Mensual", value: "month" },
        { text: "Anual", value: "year" }
      ],

      newAffiliation: {
        name: "",
        subcategory: "",
        planImage: "",
        sponsors: [],
        welcomeMessage: "",
        details: "",
        socialMedia: {
          facebook: "",
          twitter: "",
          linkedin: "",
          youtube: ""
        },
        tags: [],
        faqs: [{ question: "", answer: "" }],
        tiers: [
          {
            name: "",
            amount: 0,
            interval: "",
            benefits: []
          }
        ],
        contactDetails: {
          email: "",
          tel: "",
          webSite: ""
        },
        extraFields: [
          {
            description: "",
            fieldType: "text",
            name: "",
            formattedName: "",
            required: false
          }
        ]
        // additionalFields: [
        //   { fieldType: "text", required: false, name: "", description: "" }
        // ]
      },
      baseAffiliation: {
        name: "",
        subcategory: "",
        planImage: "",
        sponsors: [],
        welcomeMessage: "",
        details: "",
        socialMedia: {
          facebook: "",
          twitter: "",
          linkedin: "",
          youtube: ""
        },
        tags: [],
        faqs: [{ question: "", answer: "" }],
        tiers: [
          {
            name: "",
            amount: 0,
            interval: "",
            benefits: []
          }
        ],
        contactDetails: {
          email: "",
          tel: "",
          webSite: ""
        },
        extraFields: [
          {
            description: "",
            fieldType: "text",
            name: "",
            formattedName: "",
            required: false
          }
        ]
        // additionalFields: [
        //   { fieldType: "text", required: false, name: "", description: "" }
        // ]
      },

      // VALIDACIONES
      // PASO 1
      affiliationNameRules: validations.generalValidation({
        required: true,
        minLength: 5,
        maxLength: 55,
        name: "nombre de la afiliación"
      }),
      webSiteRules: validations.websiteValidation({ required: false }),
      telRules: validations.phoneValidation(),
      emailRules: validations.emailValidation(),
      amountRules: validations.requiredValidation("monto"),
      frequencyRules: validations.requiredFValidation("frecuencia"),
      reminderRules: validations.requiredValidation(
        "distribución de recordatorios"
      ),
      chargeAttemptsRules: validations.requiredFValidation(
        "cantidad de intentos de cobro"
      ),

      // PASO 2
      websiteRules: validations.websiteValidation({ required: false }),
      subcategoryRules: validations.requiredFValidation("subcategoría"),
      exampleTags: ["Ventas", "Control", "Administración"],
      search: null,

      //PASO 3
      tierNameRules: validations.requiredValidation("nombre del nivel"),
      tierPriceRules: validations.numberValidation({
        required: true,
        min: 0,
        max: 1000000,
        name: "costo"
      }),
      tierBenefitsRules: validations.comboValidation("beneficios"),
      tierIntervalRules: validations.requiredFValidation(
        "perioricidad de cobro"
      ),
      //Paso 5
      extraFieldRules: validations.extraFieldValidation(),
      //Datos bancarios
      rfcRules: validations.generalValidation({
        required: true,
        minLength: 12,
        maxLength: 13,
        name: "campo"
      }),
      razonSocialRules: validations.generalValidation({
        required: true,
        minLength: 3,
        name: "campo"
      }),
      bankRules: validations.generalValidation({
        required: true,
        name: "campo"
      }),
      clabeRules: validations.generalValidation({
        required: true,
        minLength: 18,
        maxLength: 18,
        name: "campo"
      }),
    };
  },
  computed: {...mapState("user", ["user"]),
    ...mapState("plan", ["currentPlan"])
  },
  methods: {
    ...mapMutations("notifications", ["show"]),
    ...mapMutations("loader", ["loading", "loaded"]),
    ...mapActions("user", ["updateBankDataOrganization", "checkValidationStatus"]),
    ...mapActions("plan", [
      "createPlan",
      "updatePlan",
      "saveImage",
      "fetchPlanDetails"
    ]),
    handleFilePondInit: function() {},
    /**
     * Función para validar que los campos del formulario hayan sido llenados de la forma correcta.
     */
    validate() {
      if (this.$refs.form.validate()) {
        this.snackbar = true;
        this.currentStep++;
      }
      return false;
    },
    /**
     * Función para eliminar preguntas frecuentes
     */
    deleteQuestion(question) {
      let newFaq = this.newAffiliation.faqs.filter(
        item => item.question != question
      );
      this.newAffiliation.faqs =
        newFaq.length > 0 ? newFaq : [{ question: "", answer: "" }];
    },
    /**
     * Función para añadir una pregunta frecuente
     */
    addQuestion() {
      this.newAffiliation.faqs.push({ question: "", answer: "" });
    },
    /**
     * Función para eliminar un campo extra
     */
    deleteField(fieldName) {
      let newFields = this.newAffiliation.extraFields.filter(
        field => field.name != fieldName
      );
      this.newAffiliation.extraFields =
        newFields.length > 0
          ? newFields
          : [{ fieldType: "text", required: false, name: "", description: "" }];
    },
    /**
     * Función para agregar un campo extra
     */
    addField() {
      this.newAffiliation.extraFields.push({
        fieldType: "text",
        required: false,
        name: "",
        formattedName: "",
        description: ""
      });
    },
    /**
     * Función para eliminar un nivel del plan(Afiliación)
     */
    deleteTier(tierName) {
      let newTiers = this.newAffiliation.tiers.filter(
        tier => tier.name != tierName
      );
      this.newAffiliation.tiers =
        newTiers.length > 0
          ? newTiers
          : [{ name: "", amount: 0, interval: "", benefits: [] }];
    },
    /**
     * Función para agregar un nivel del plan(Afiliación)
     */
    addTier() {
      this.newAffiliation.tiers.push({
        name: "",
        amount: 0,
        interval: "",
        benefits: []
      });
    },
    /**
     * Función para validar niveles del plan(Affiliación).
     */
    checkTiers() {
      if (this.newAffiliation.tiers) {
        if (this.$refs.form.validate()) {
          this.currentStep++;
          this.snackbar = true;
        } else return false;
      }
    },
    /**
     * Validar longitud de beneficios de nivel de afiliación.
     * @param { Int } tierIndex Indice que apunta a la posición del arreglo en la que se encuentra el nivel a validar.
     */
    validateBenefitLength(tierIndex) {
      this.newAffiliation.tiers[tierIndex].benefits = this.newAffiliation.tiers[
        tierIndex
      ].benefits.filter(benefit => {
        if (benefit.length > 60)
          this.show({
            text: `¡El beneficio no debe superar los 60 caracteres! 😬`
          });
        else return benefit;
      });
    },
    /**
     * Función para dar formato a los campos extra y evitar que den errores por poner caracteres extraños.
     */
    async formatExtraFields() {
      var patron = / /g;
      var patronSigns = /[¿?]/g;
      var newValor = "_";
      var newValorSigns = "";
      var lowerlettera = /á/g,
        lowerlettere = /é/g,
        lowerletteri = /í/g,
        lowerlettero = /ó/g,
        lowerletteru = /ú/g,
        lowerlettern = /ñ/g,
        upperlettera = /Á/g,
        upperlettere = /É/g,
        upperletteri = /Í/g,
        upperlettero = /Ó/g,
        upperletteru = /Ú/g,
        upperlettern = /Ñ/g;

      var lowera = "a",
        lowere = "e",
        loweri = "i",
        lowero = "o",
        loweru = "u",
        lowern = "n",
        uppera = "A",
        uppere = "E",
        upperi = "I",
        uppero = "O",
        upperu = "U",
        uppern = "N";
      for (let i=0; i < this.newAffiliation.extraFields.length; i++) {
        if (this.newAffiliation.extraFields[i].name == "") {
          this.newAffiliation.extraFields.splice(i, 1);
        }
      }
      if (this.newAffiliation.extraFields.length > 0 && this.newAffiliation.extraFields[this.newAffiliation.extraFields.length-1].name === "") {
        this.newAffiliation.extraFields.pop();
      }
      let newExtraFields = await Promise.all(
        this.newAffiliation.extraFields.map(async extraField => {
          return await extraField.name
            .replace(patron, newValor)
            .replace(patronSigns, newValorSigns)
            .replace(lowerlettera, lowera)
            .replace(lowerlettere, lowere)
            .replace(lowerletteri, loweri)
            .replace(lowerlettero, lowero)
            .replace(lowerletteru, loweru)
            .replace(lowerlettern, lowern)
            .replace(upperlettera, uppera)
            .replace(upperlettere, uppere)
            .replace(upperletteri, upperi)
            .replace(upperlettero, uppero)
            .replace(upperletteru, upperu)
            .replace(upperlettern, uppern);
        })
      );
      newExtraFields.forEach((element, index, array) => {
        this.newAffiliation.extraFields[index].formattedName = element;
      });
    },
    /**
     * Función para validar el estatus del organizador que quiere crear su primer plan(Afiliación).
     * (LA FUNCIÓN VERIFICA QUE EL ORGANIZADOR YA HAYA PROPORCIONADO SUS DATOS BANCARIOS).
     */
    async validateOrganizerStatus(method) {
      if(this.user.validationStatus==undefined || this.user.validationStatus==null || this.user.validationStatus == 'NOT_VALIDATED' || this.user.validationStatus == 'REJECTED' ) {
        this.bankDataDialog = true;
      }else {
        if(method=='create') {
          await this.save();
        } else if(method=='update') {
          await this.update();
        }
      }
    },
    /**
     * Función para editar los datos bancarios de la organización que esta publicando el plan(Afiliación).
     */
    async editOrganization(bankData) {
      delete this.bankDataOrganization.confirmClabe;
      await this.updateBankDataOrganization(bankData);
      this.user.validationStatus = "IN_PROCESS";
      this.show({ text: "¡Información bancaria guardada con éxito! 😄" });
      this.bankDataDialog = false;
    },
    /**
     * Función para guardar el plan
     */
    async save() {
      this.loading();
      // Si subió imagen de la afiliación subir al bucket de Amazon S3 y obtener la url de la imagen.
      if (this.newAffiliation.planImage != "") {
        let planImage = await imageHelper.saveImage(
          this.newAffiliation.planImage
        );
        this.newAffiliation.planImage = planImage;
      }
      // Si subió imagenes de patrocinadores subirlas al bucket de Amazon de S3 y obtener las URL de las imágenes.
      if (this.newAffiliation.sponsors.length != 0) {
        let sponsorsImages = await Promise.all(
          this.newAffiliation.sponsors.map(async sponsor => {
            return await imageHelper.saveImage(sponsor);
          })
        );
        this.newAffiliation.sponsors = sponsorsImages;
      }
      // Codificar en base64 los detalles del plan.
      this.newAffiliation.details = Base64.encode(this.newAffiliation.details);
      // Codificar en base64 el mensaje de bienvenida del plan.
      this.newAffiliation.welcomeMessage = Base64.encode(this.newAffiliation.welcomeMessage);
      await this.formatExtraFields();
      let newAffiliationName = await this.createPlan(this.newAffiliation);
      this.loaded();
      this.show({
        text: `¡Afiliación ${newAffiliationName} guardada con éxito! 😄`
      });
      this.$router.push("/dashboard/afiliaciones");
    },
    async update() {
      this.loading();
      // Si subió imagen de la afiliación subir al bucket de Amazon S3 y obtener la url de la imagen.
      if (typeof this.newAffiliation.planImage != "string") {
        let planImage = await imageHelper.saveImage(
          this.newAffiliation.planImage
        );
        this.newAffiliation.planImage = planImage;
      }
      // Si subió imagenes de patrocinadores subirlas al bucket de Amazon de S3 y obtener las URL de las imágenes.
      if (typeof this.newAffiliation.sponsors[0] != "string") {
        let sponsorsImages = await Promise.all(
          this.newAffiliation.sponsors.map(async sponsor => {
            return await imageHelper.saveImage(sponsor);
          })
        );
        this.newAffiliation.sponsors = sponsorsImages;
      }
      // Codificar en base64 los detalles del plan.
      this.newAffiliation.details = Base64.encode(this.newAffiliation.details);
      // Codificar en base64 el mensaje de bienvenida del plan.
      this.newAffiliation.welcomeMessage = Base64.encode(this.newAffiliation.welcomeMessage);
      await this.formatExtraFields();
      await this.updatePlan(this.newAffiliation);
      this.loaded();
      this.show({ text: `¡Afiliación actualizada con éxito! 😄` });
      this.$router.push("/dashboard/afiliaciones");
    },
    /**
     * Función para procesar imágenes del plan(Afiliación) y patrocinadores.
     * (SE AJUSTAN TAMAÑOS Y SE CAMBIAN LOS NOMBRES)
     */
    async processFile() {
      if (this.$refs.pondAffiliation.getFiles().length > 0) {
        this.newAffiliation.planImage = await imageHelper.resizeImg(
          this.$refs.pondAffiliation.getFiles()[0].file,
          1920,
          750
        );
      }
      if (this.$refs.pondSponsors.getFiles().length > 0) {
        this.newAffiliation.sponsors = await imageHelper.resizeImgs(
          this.$refs.pondSponsors.getFiles()
        );
      }
    }
  },
  async mounted() {
    this.isNewAffiliation =
      this.$route.fullPath.split("/")[2] === "modificar-afiliacion"
        ? false
        : true;
    /* Verificar si se esta editando el plan, si es así realizar ajustes a las variables
      para asignar valores por default si es que el objeto de la afiliación no cuenta con ellos.
      Esto puede causarse porque constantemente se agregan nuevas funciones y en algunas
      ocasiones los planes que ya estaban creados no cuentan con ciertos campos requeridos
      que son necesarios para poder funcionar con las nuevas funciones agregadas.*/
    if (!this.isNewAffiliation) {
      await this.fetchPlanDetails(this.$route.params.id);
      this.newAffiliation = this.currentPlan;
      this.originalTiersQty = this.newAffiliation.tiers.length;

      //Formatear respuesta de preguntas frecuentes
      if (this.newAffiliation.faqs.length > 0) {
        this.newAffiliation.faqs.forEach(faq => {
          faq.answer = Base64.decode(faq.answer);
        });
        for (let i = 0; i < this.newAffiliation.faqs.length; i++) {
          if (this.newAffiliation.faqs[i].question == "") {
            this.newAffiliation.faqs.splice(i, 1);
          }
        }
      }
      /* Si el plan no cuenta con una pregunta frecuente agregarla para que aparezcan
        los campos de una pregunta freguente en el formulario de editar afiliación.*/
      if (this.newAffiliation.faqs.length === 0) {
        this.addQuestion();
      }

      // Formatear descripción del plan.
      this.newAffiliation.details = Base64.decode(this.newAffiliation.details);
      // Formatear mensaje de bienvenida que saldrá en el correo que le sale a los afiliados cada vez que pagan una afiliación.
      this.newAffiliation.welcomeMessage = Base64.decode(this.newAffiliation.welcomeMessage);
      // Formatear campos extra.
      if (
        this.newAffiliation.extraFields &&
        this.newAffiliation.extraFields.length > 0 &&
        this.newAffiliation.extraFields[0].name != ""
      ) {
        this.additionalFields = true;
      } else {
        this.newAffiliation.extraFields = [
          {
            description: "",
            fieldType: "text",
            formattedName: "",
            name: "",
            required: false
          }
        ];
      }
    }
  },
  watch: {
    $route(to, from) {
      if (to.path === "/dashboard/nueva-afiliacion") {
        this.isNewAffiliation = true;
        this.newAffiliation = JSON.parse(JSON.stringify(this.baseAffiliation));
        this.currentStep = 1;
      }
    }
  }
};
</script>